import { Subject } from 'rxjs';
import { Injectable } from "@angular/core";

@Injectable()
export class TaskCountService {
  getTaskCount = new Subject();
}
